export const getQAFromDom = () => {
  const sendMsg =
    document.getElementById("qa-question")?.innerText.replace(/\\n/g, "\n") ||
    "";
  const recvMsg =
    document.getElementById("qa-answer")?.innerText.replace(/\\n/g, "\n") || "";

  if (!!sendMsg || !!recvMsg) {
    return {
      sendMsg,
      recvMsg,
    };
  }
  return undefined;
};

export const getGuessFromDom = () => {
  const guess0 =
    document.getElementById("qa-guess0")?.innerText.replace(/\\n/g, "\n") || "";
  const guess1 =
    document.getElementById("qa-guess1")?.innerText.replace(/\\n/g, "\n") || "";
  const guess2 =
    document.getElementById("qa-guess2")?.innerText.replace(/\\n/g, "\n") || "";
  if (guess0 && guess1 && guess2) {
    return [guess0, guess1, guess2];
  }
  return null;
};
